import template from "./new-report.html";

function controller(appState, reportScopeFactory) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.reportScope = reportScopeFactory.create({
			form: appState.forms.selected,
			report: ctrl.report
		});
	};
}

export default angular
	.module("vesl.screens.new-report", [])
	.component("newReport", {
		template,
		controller,
		bindings: { report: "<" }
	}).name;
